// CLO-11872: Only the asset General form reserves these two vehicle-question rows.
// Keep original positions per DOM element so updates cannot accumulate offsets.
const ORIGINAL_ROWS = new WeakMap();

export const collapseAssetForceGroups = (root = document) => {
  root.querySelectorAll('[id="form-ASST"]').forEach(form => {
    const FORCE_ACTUAL_INPUT = form.querySelector('[id="815000"].form-group-8');
    const FORCE_STANDARD_INPUT = form.querySelector('[id="817000"].form-group-7');
    const ACRS_YES_INPUT = form.querySelector('[id="817200"].form-group-1');
    const ACRS_NO_INPUT = form.querySelector('[id="817300"].form-group-1');
    const ACRS_LABEL = Array.from(form.querySelectorAll('.form-group-1'))
      .map(element => element.closest('.form-textitem'))
      .find(Boolean);
    if (
      !FORCE_ACTUAL_INPUT ||
      !FORCE_STANDARD_INPUT ||
      !ACRS_YES_INPUT ||
      !ACRS_NO_INPUT ||
      !ACRS_LABEL
    ) {
      return;
    }

    const ACRS_ELEMENTS = [
      ACRS_LABEL,
      ACRS_YES_INPUT.closest('.form-element'),
      ACRS_NO_INPUT.closest('.form-element'),
    ];
    const FORCE_ACTUAL_ROW = FORCE_ACTUAL_INPUT.closest('.form-element');
    if (!FORCE_ACTUAL_ROW || ACRS_ELEMENTS.some(element => !element)) return;

    ACRS_ELEMENTS.forEach(element => {
      if (!ORIGINAL_ROWS.has(element)) {
        ORIGINAL_ROWS.set(element, {
          start: element.style.gridRowStart,
          end: element.style.gridRowEnd,
        });
      }
    });

    if (
      !/^\d+$/.test(FORCE_ACTUAL_ROW.style.gridRowStart) ||
      ACRS_ELEMENTS.some(element => !/^\d+$/.test(ORIGINAL_ROWS.get(element).start))
    ) {
      return;
    }

    const IS_FORCE_GROUP_LAYOUT_COLLAPSED = Array.from(
      form.querySelectorAll('.form-group-7, .form-group-8'),
    ).every(element => element.classList.contains('hide'));
    const ROW_OFFSET =
      Number(ORIGINAL_ROWS.get(ACRS_ELEMENTS[1]).start) - Number(FORCE_ACTUAL_ROW.style.gridRowStart);
    if (!Number.isFinite(ROW_OFFSET) || ROW_OFFSET <= 0) return;

    ACRS_ELEMENTS.forEach(element => {
      const { start: START, end: END } = ORIGINAL_ROWS.get(element);
      // Preserve spans/auto values, and restore the exact original inline styles.
      element.style.gridRowStart = IS_FORCE_GROUP_LAYOUT_COLLAPSED
        ? String(Number(START) - ROW_OFFSET)
        : START;
      element.style.gridRowEnd =
        IS_FORCE_GROUP_LAYOUT_COLLAPSED && /^\d+$/.test(END) ? String(Number(END) - ROW_OFFSET) : END;
    });
  });
};
